import i18n from 'i18next';

export default ({ id, isChildLocale = false }) => ({
  seo_title: {
    type: 'Text',
    label: i18n.t('seo-title'),
    help: i18n.t('seo-title-help'),
    validators: [{ type: 'isNotEmptyString' }],
  },
  seo_description: {
    type: 'TextArea',
    label: i18n.t('seo-description'),
    help: i18n.t('seo-description-help'),
    validators: [{ type: 'isNotEmptyString' }],
  },
  ...(!isChildLocale && {
    url_slug: {
      type: 'Text',
      label: i18n.t('url-slug'),
      help: i18n.t('url-slug-help', { id }),
      validators: [{ type: 'isNotEmptyString' }, { type: 'isUrlSlug' }],
    },
    robots_meta_tags: {
      type: 'Text',
      label: i18n.t('robots-meta-tags'),
      help: i18n.t('robots-meta-tags-help'),
      validators: [{ type: 'isNotEmptyString' }, { type: 'isStringCSV' }],
    },
  }),
});
